"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedStructureBranchingQuery = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const edgeTypeMatrixFns_1 = require("../classDependentTypes/EdgeTypes/edgeTypeMatrixFns");
const BranchingQueryDefinition_1 = require("../util/dynamodb/GraphQuery/BranchingQueryDefinition");
const debug_1 = require("../util/lambda/debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
/** returns a query definition to traverse the grouper -> grouper and containedType nested data
 * This query does not deal with customer - group - customer - group structure types. For this use desendingGroupHierarchy file://./descendingGroupHierarchy.ts
 * Testing is by utility: file:///.//../../../..//Utilities/src/TestData/EntityGroupsAndEntities/index.ts
 * This is used in group visibility use cases where the users group and determines what groups are allowed via the allowsGroup edgeType
 *
 * Note, as the initial query must do Grouper -> Grouper and have subQueries added, the top level Grouper items will not have the Grouper -> SupportedType query run against it, this needs to (currently 2024 05) be done by callers
 */
const getNestedStructureBranchingQuery = ({ groupObjectType, containedObjectType, traversal, includeSupportedTypeInstances, addIdPrefixes = true, finalSubQueries, }) => {
    let queryDef = null;
    const idPrefix = addIdPrefixes ? `${groupObjectType}-${containedObjectType}-${traversal}-` : '';
    const grouperAdjacentType = iotv_v3_types_1.TraversalToAdjacentType[traversal];
    const grouperGrouperEdgeTypeId = (0, edgeTypeMatrixFns_1.getChildEdgeTypeId)(groupObjectType, groupObjectType); // should always resovle to group_has_subGroup
    const grouperContainedTypeEdgeTypeId = (0, edgeTypeMatrixFns_1.getChildEdgeTypeId)(groupObjectType, containedObjectType);
    if (grouperGrouperEdgeTypeId && grouperContainedTypeEdgeTypeId) {
        const groupToGroupTypeQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
            id: `${idPrefix}groupToGroupDefiningTypeQuery`,
            path: [
                {
                    objectTypeId: groupObjectType,
                    adjacencyType: grouperAdjacentType,
                    edgeTypeId: grouperGrouperEdgeTypeId,
                    nodeFilters: [],
                },
            ],
            subQueries: finalSubQueries ?? [],
        });
        if (groupObjectType === 'Group') {
            groupToGroupTypeQuery.path.at(0)?.nodeFilters?.push({
                setOperation: iotv_v3_types_1.LogicalOperatorType.AND,
                filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: containedObjectType }],
            });
        }
        if (includeSupportedTypeInstances) {
            const groupToContainedTypeQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
                id: `${idPrefix}groupToContainedTypeQuery`,
                path: [{ objectTypeId: containedObjectType, adjacencyType: iotv_v3_types_1.AdjacentType.CHILD, edgeTypeId: grouperContainedTypeEdgeTypeId }],
                subQueries: [],
            });
            groupToGroupTypeQuery.addSubQuery(groupToContainedTypeQuery);
        }
        groupToGroupTypeQuery.addSubQuery(groupToGroupTypeQuery);
        queryDef = groupToGroupTypeQuery;
    }
    return queryDef;
};
exports.getNestedStructureBranchingQuery = getNestedStructureBranchingQuery;
